import img1 from '../image/football1.jpg';
import img2 from '../image/football2.jpg';
import img3 from '../image/work1.jpg';
import img4 from '../image/work2.jpg';
import img5 from '../image/mountain1.jpg';
import img6 from '../image/mountain2.jpg';
export const cardsData = [
    {
        id: 1,
        url: img3,
    },
    {
        id: 2,
        url: img1,
    },
    {
        id: 3,
        url: img5,
    },
    {
        id: 4,
        url: img2,
    },
    {
        id: 5,
        url: img4,
    },
    {
        id: 6,
        url: img6,
    },
];